import React from "react";

function Divider({ vertical }) {
  return <div className={`tcf-divider ${vertical ? "vertical" : ""}`} />;
}

export default Divider;
